<template>
    <div class="DM_transctionInfo">
        <!-- 交易明细详情 -->
        <el-dialog :visible="infoIsShow" @close="handleClose" :close-on-click-modal="false">
            <el-card class="box-card" shadow="hover">
                <div class="purseTitle">
                    <div>交易信息</div>
                </div>
                <el-row class="rowTitle">
                    <el-col :sm="24" :md="24" :lg="24">
                        <span class="labels">订单号：</span>
                        <span>{{detail.transaction_number}}</span>
                    </el-col>
                </el-row>
				<el-row class="rowTitle">
				    <el-col :sm="12" :md="12" :lg="8">
				        <span class="labels">政策：</span>
				        <span>{{detail.name}}</span>
				    </el-col>
				    <el-col :sm="12" :md="12" :lg="8">
				        <span class="labels">终端SN：</span>
				        <span>{{detail.terminal_sn}}</span>
				    </el-col>
				    <el-col :sm="12" :md="12" :lg="8">
				        <span class="labels">终端归属用户账号：</span>
				        <span>{{detail.phone}}</span>
				    </el-col>
					<el-col :sm="12" :md="12" :lg="8">
					    <span class="labels">终端归属用户名称：</span>
					    <span>{{detail.real_name}}</span>
					</el-col>
				    <el-col :sm="12" :md="12" :lg="8">
				        <span class="labels">交易金额：</span>
				        <span>{{detail.transaction_money}}</span>
				    </el-col>
				    <el-col :sm="12" :md="12" :lg="8">
				        <span class="labels">交易分润：</span>
				        <span>{{detail.income}}</span>
				    </el-col>
				    <el-col :sm="12" :md="12" :lg="8">
				        <span class="labels">交易时间：</span>
				        <span>{{detail.transaction_time}}</span>
				    </el-col>
				</el-row>
                <div class="purseTitle" v-if="detail.type==1 || detail.type==2">
                    <div>各级交易分润详情</div>
                </div>
                <el-table v-if="detail.type==1 || detail.type==2"
                    :data="rate_list"
                    size="mini"
                    height="200"
                    border
                    style="width: 100%"
                    v-loading="loading"
                >
                    <!-- id -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="序号"
                        min-width="80"
                    ></el-table-column>
                    <!-- 代理名称 -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="nickname"
                        label="代理名称"
                        min-width="120"
                    ></el-table-column>
                    <!-- 层级 -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="level"
                        label="层级"
                        min-width="120"
                    ></el-table-column>
                    <!-- 政策 -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="percent"
                        label="比例(%)"
                        min-width="150"
                    ></el-table-column>
                    <!-- 分润 -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="profit"
                        label="分润"
                        min-width="120"
                    ></el-table-column>
                </el-table>
				<div class="purseTitle" v-if="detail.type==1 || detail.type==3">
				    <div>各级交易秒到费详情</div>
				</div>
				<el-table v-if="detail.type==1 || detail.type==3"
				    :data="sec_fee_list"
				    size="mini"
				    height="200"
				    border
				    style="width: 100%"
				    v-loading="loading"
				>
				    <!-- id -->
				    <el-table-column
				        header-align="center"
				        align="center"
				        fixed
				        type="index"
				        label="序号"
				        min-width="80"
				    ></el-table-column>
				    <!-- 代理名称 -->
				    <el-table-column
				        header-align="center"
				        align="center"
				        prop="nickname"
				        label="代理名称"
				        min-width="120"
				    ></el-table-column>
				    <!-- 层级 -->
				    <el-table-column
				        header-align="center"
				        align="center"
				        prop="level"
				        label="层级"
				        min-width="120"
				    ></el-table-column>
				    <!-- 政策 -->
				    <el-table-column
				        header-align="center"
				        align="center"
				        prop="percent"
				        label="比例(%)"
				        min-width="150"
				    ></el-table-column>
				    <!-- 分润 -->
				    <el-table-column
				        header-align="center"
				        align="center"
				        prop="profit"
				        label="分润"
				        min-width="120"
				    ></el-table-column>
				</el-table>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "DM_transctionInfo",
    props: {
        infoIsShow: {
            type: Boolean,
            default: false
        },
        detail: {
            type: Object
        }
    },
    data() {
        return {
			// detail:[],
            level:sessionStorage.getItem('level'),
            rate_list: [], //表格
            sec_fee_list: [], //表格
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            id: null,
            loading: true,
        }
    },
    mounted() {
        this.id = this.detail.transaction_id;
        // this.detail = this.detail;
        this.getData();
    },
    methods: {
        handleClose() {
            this.$emit('infoClose')
        },
        getData() {
            this.$api.post("terminal/terminal_adjust_detail_percent", { id: this.detail.transaction_id }, res => {
                let data = res.data;
                if (res.code == 0) {
                    this.rate_list = data.rate_list;
                    this.sec_fee_list = data.sec_fee_list;
                    //渲染结束后取消加载
                    this.loading = false;
                } else {
                    this.$message.error(res.msg);
                    //渲染结束后取消加载
                    this.loading = false;
                }
            })
        }
    }
};
</script>

<style lang="scss" scope>
.DM_transctionInfo {
    .purseTitle {
        font-size: 12px;
        margin: 10px 0;
        color: #909399;
        :nth-child(1) {
            font-weight: 700;
            color: #7f7f7f;
            padding-left: 10px;
            border-left: 4px solid #909399;
        }
    }
    .rowTitle {
        color: #909399;
        font-size: 12px;
        .el-col {
            margin: 5px 0;
        }
        .labels {
            font-weight: 700;
        }
    }
}
</style>
